export default __webpack_public_path__ + "static/media/leftImage.5a291f1d.png";